import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";
import LocalizationContext from "../../../providers/localization/LocalizationContext";
import LayoutComponent from "../../../layouts/layoutComponent/LayoutComponent";
import CreateStablishmentComponent from "../list/form/create_stablishment.component";
import StablishmentEntity from "../../../../domain/entities/StablishmentEntity";
import routes from "../../../routes/Routes";

const CreateStablishmentPage: FC<{}> = () => {
    const { i18n } = useContext(LocalizationContext);
    const navigate = useNavigate();

    const handleOnCreated = (stablishment: StablishmentEntity) => {
        navigate(routes.stablishment_list.relativePath);
    };

    return (
        <LayoutComponent title={i18n("Crear Establecimiento")}>
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="mb-0">{i18n("Nuevo Establecimiento")}</h4>
                            </div>
                            <div className="card-body">
                                <CreateStablishmentComponent onCreated={handleOnCreated} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutComponent>
    );
};

export default CreateStablishmentPage;